/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Draft_Row_RemovedInputs */

const en_us2_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leaves ${i?.session}`)
};

const pt_br2_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sai do ${i?.session}`)
};

const es_419_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sale de ${i?.session}`)
};

const pt_pt2_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sai do ${i?.session}`)
};

const fr_fr2_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sort de ${i?.session}`)
};

const de_de2_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Raus aus ${i?.session}`)
};

const it_it2_draft_row_removed = /** @type {(inputs: Draft_Row_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esce da ${i?.session}`)
};

/**
* | output |
* | --- |
* | "Leaves {session}" |
*
* @param {Draft_Row_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_row_removed = /** @type {((inputs: Draft_Row_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Row_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_row_removed(inputs)
	if (locale === "es-419") return es_419_draft_row_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_row_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_row_removed(inputs)
	if (locale === "de-DE") return de_de2_draft_row_removed(inputs)
	if (locale === "it-IT") return it_it2_draft_row_removed(inputs)
	return en_us2_draft_row_removed(inputs)
});
export { draft_row_removed as "draft.row_removed" }